import { Link } from "react-router-dom";

const MARK = "/brand/restpower-mark.png";

export function LogoMark({ size = 34, className = "" }) {
  return (
    <img
      src={MARK}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={className}
      style={{ height: size, width: "auto", objectFit: "contain" }}
    />
  );
}

export default function Logo({ onClick, className = "" }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={`group flex items-center gap-2.5 ${className}`}
      data-testid="logo-link"
      aria-label="RestPower home"
    >
      <LogoMark size={32} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-xl font-bold tracking-tight text-white">
          REST<span className="text-rp-accent">POWER</span>
        </span>
        <span className="mt-1 hidden font-mono text-[9px] uppercase tracking-[0.18em] text-white/40 sm:block">
          More Than a Charge
        </span>
      </span>
    </Link>
  );
}
